<style lang="scss" scoped>
  .product-image {
    min-height: 300px;
    background-size: cover;
    background-position: center center;
  }

  .product-description {
    height: 120px;
  }
</style>

<template>
  <div>
    <div v-if="category">
      <div class="fz24 light mt2">{{ category.name }}</div>
      <p class="mt2 mb2">Utforsk varesortimentet nedenfor og plasser bestillingen via handlekurven.</p>
      <div>
        <div class="clearfix mxn2">
          <div class="sm-col sm-col-12 md-col-6 lg-col-4 xl-col-3 px2 mb3"
               v-for="product in category.products">
            <div class="card rounded sh1">
              <div class="p2 bold pointer" @click="viewProduct(product.id)">{{ product.name }}</div>
              <!--
              <div class="product-image pointer" :style="getProductImage(product)" @click="viewProduct(product.id)"></div>
              -->
              <div>
                <img class="pointer" :src="getPicture(product)"  @click="viewProduct(product.id)" alt="">
              </div>
              <div class="p2 product-description">{{ product.short_description }}</div>
              <div class="border-bottom border-light-grey"></div>
              <div class="p2">
                <md-button class="md-raised md-primary right m0" @click.native="viewProduct(product.id)">Kjøp</md-button>
                <div>
                  <div class="text-grey fz12">Fra</div>
                  <div class="bold text-grey fz18">kr {{ toLocale(product.from_price) }},-</div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p3 center" v-else>
      <md-spinner md-indeterminate></md-spinner>
    </div>
  </div>
</template>

<script>
  import apiCategory from '@/js/api/category';
  import hasPrices from '@/js/mixins/hasPrices';
  import hasPictures from '@/js/mixins/hasPictures';

  export default {
    mixins: [hasPrices, hasPictures],

    data() {
      return {
        category: null,
      };
    },

    mounted() {
      this.fetch(this.$route.params.categoryId);
    },

    beforeRouteUpdate(to, from, next) {
      // Reset
      this.category = null;

      this.fetch(to.params.categoryId);

      next();
    },

    methods: {
      fetch(slug) {
        apiCategory.show(slug).then(this.onFetchSuccess);
      },

      onFetchSuccess(response) {
        this.category = response.data.data;
        // this.state.stop('loading');
      },

      viewProduct(id) {
        this.$router.push({ name: 'view-product', params: { productId: id } });
      },

      getProductImage(product) {
        return `background-image: url('${product.image_url}')`;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// ProductCategory.vue?b3c9764e